export const ComboQcFieldName = 'comboQcFieldComponent';
